import React, {useState, useMemo} from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from 'reactstrap';
import clsx from 'clsx';

function ActionIcon({
  className, 
  icon, 
  onClick = () => {}, 
  tag: Tag = "span", 
  disabled, 
  tooltip,
  tooltipId,
  ...props
}) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const innerTooltipId = useMemo(() => {
    return `Action-${tooltip?.replace(/ /g, '-')?.toLowerCase()}-${tooltipId}`;
  }, [tooltip, tooltipId])
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const handleClick = () => {
    if (disabled) return
    onClick()
  }

  return (  
    <>
     { tooltip && 
      <Tooltip target={innerTooltipId} isOpen={tooltipOpen} toggle={toggle}>
        {tooltip}
      </Tooltip>
      }
      <Tag {...props} className={clsx(`text-sm rounded`, className)} id={innerTooltipId} onClick={handleClick} >{/*action-bg text-light*/}
          <FontAwesomeIcon className={clsx(disabled ? `text-muted` : 'text-dark')} size="lg" icon={icon} fixedWidth />
      </Tag>
    </>
  )
}

ActionIcon.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.string,
  className: PropTypes.string,
}

export default ActionIcon

